import apiClient from './axiosConfig';
import { API_ENDPOINTS } from '../constants';

const CACHE_EXPIRATION_TIME = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
const ADMIN_CACHE_KEY_ALL_SETTINGS = 'admin_all_settings_cache';
const ADMIN_CACHE_KEY_PREFIX_SETTING_BY_KEY = 'admin_setting_by_key_';

const settingsApi = {
  getSettings: async () => {
    const cachedData = localStorage.getItem(ADMIN_CACHE_KEY_ALL_SETTINGS);

    if (cachedData) {
      const { data, timestamp } = JSON.parse(cachedData);
      if (Date.now() - timestamp < CACHE_EXPIRATION_TIME) {
        return data; // Return the full cached data object (e.g., { success: true, data: { ... } })
      } else {
        localStorage.removeItem(ADMIN_CACHE_KEY_ALL_SETTINGS); // Remove expired cache
      }
    }

    try {
      const response = await apiClient.get(API_ENDPOINTS.SETTINGS);
      localStorage.setItem(ADMIN_CACHE_KEY_ALL_SETTINGS, JSON.stringify({ data: response.data, timestamp: Date.now() }));
      return response.data; // Return the full response data
    } catch (error) {
      console.error('Error fetching all admin settings:', error);
      throw error;
    }
  },

  getSettingByKey: async (key) => {
    const cacheKey = `${ADMIN_CACHE_KEY_PREFIX_SETTING_BY_KEY}${key}`;
    const cachedData = localStorage.getItem(cacheKey);

    if (cachedData) {
      const { data, timestamp } = JSON.parse(cachedData);
      if (Date.now() - timestamp < CACHE_EXPIRATION_TIME) {
        return data; // Return the cached individual setting data (e.g., { success: true, data: { key: "favicon", value: "..." } })
      } else {
        localStorage.removeItem(cacheKey); // Remove expired cache
      }
    }

    // If not in individual cache or expired, fetch all settings and extract
    try {
      const allSettingsResponse = await settingsApi.getSettings(); // This will use its own cache or hit API
      if (allSettingsResponse.success && allSettingsResponse.data && allSettingsResponse.data[key] !== undefined) {
        // Construct a response object similar to what a direct getSettingByKey might return
        const individualSettingData = {
          success: true,
          message: `Setting ${key} retrieved successfully.`,
          error: null,
          data: {
            key: key,
            value: allSettingsResponse.data[key]
          }
        };
        localStorage.setItem(cacheKey, JSON.stringify({ data: individualSettingData, timestamp: Date.now() }));
        return individualSettingData;
      } else {
        // If the key is not found in the all settings response
        return {
          success: false,
          message: `Setting ${key} not found.`,
          error: 'Not Found',
          data: null
        };
      }
    } catch (error) {
      console.error(`Error fetching admin setting for key ${key} via all settings:`, error);
      throw error;
    }
  },
};

export default settingsApi;